import createIcon from "@impero-com/common/img/create-icon.svg";
import { useTranslation } from "@impero-com/common/utils/i18n";
import { ActionSpec, NoContent } from "@impero-com/ui";

import { OrgApplicationBar } from "../../../../components/applicationBar/orgApplicationBar";
import { WebRoute } from "../../../../routes";
import { useAvailableActions } from "../../../../utils/hooks/useAvailableActions";

import { useTestingProgramsQuery } from "./queries/useTestingProgramsQuery";
import { TestingProgramList } from "./TestingProgramList";

export function TestingProgramListPage() {
    const { t } = useTranslation();
    const availableActions = useAvailableActions();
    const canCreate = availableActions.testingProgram.create;
    const actions: ActionSpec[] = [
        {
            id: "newTestingProgram",
            icon: { svg: createIcon },
            label: t("ControlTesting_Action_NewTestingProgram"),
            status: canCreate
                ? { type: "ENABLED" }
                : {
                      type: "DISABLED",
                      reason: t(
                          "ControlTesting_Action_NewTestingProgram_Disabled"
                      ),
                  },
            link: {
                to: WebRoute.TESTING_PROGRAMS_NEW,
            },
        },
    ];

    const { data } = useTestingProgramsQuery();
    const hasPrograms = data.content.length > 0;

    return (
        <OrgApplicationBar
            title={t("ControlTesting_ModuleTitle")}
            actions={{ id: "testingProgramList", actions }}
        >
            {hasPrograms ? (
                <TestingProgramList data={data} />
            ) : (
                <NoContent
                    header={t("TestingProgramList_NoContent_Header")}
                    description={t("TestingProgramList_NoContent_Description")}
                    actionCreation={
                        canCreate
                            ? {
                                  type: "ROUTER",
                                  label: t(
                                      "TestingProgramList_NoContent_Action"
                                  ),
                                  to: WebRoute.TESTING_PROGRAMS_NEW,
                              }
                            : undefined
                    }
                />
            )}
        </OrgApplicationBar>
    );
}
